var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "docs/excel"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    width: 20,
    height: 20,
    rx: 4,
    fill: "#5986DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M6.07358 16L3 5H4.96743L6.90109 12.8162H6.93486L9.32449 5H10.6755L13.0567 12.8162H13.0905L15.0326 5H17L13.9264 16H12.3643L10.0169 8.07064H9.98311L7.62726 16H6.07358Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.cb6cb830401f230295f9ca11f089acdb.svg";
export { ForwardRef as ReactComponent };